// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/create-portfolio-from-existing/app/css/app.css
// module id = 810
// module chunks = 0